<template>
  <div>
      <div class="text-center" v-if="Loading">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>

    <div class="panal mt-20" v-else-if="!Loading && selectEvent.length >0">
      <div class="panal-header"> {{selectEvent[0].NameEN ? selectEvent[0].NameEN : ''}} </div>
      <div class="panal-body">

 <h5>Event Description</h5>
       <p>Address: {{selectEvent[0].GovernorateNameEN}}, {{selectEvent[0].Address}} </p>
       <p>Date: From {{selectEvent[0].StartDate | moment('ll')}} To {{selectEvent[0].EndDate | moment('ll')}} </p> 

        <div class="divider"></div>

<h5>Faculties interested in </h5>
 <b-form @submit="onSubmit"  v-if="show">

     <b-form-group id="input-group-11" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
         
          id="checkboxes-11"
          :aria-describedby="ariaDescribedby"
        >
     <div class="row mb-3">
<div class="col-md-1"></div>


<div class="col-md-5" v-for="camp in campFac" :key="camp.BranchSerial">
<div class="border">
    <div class="title">{{camp.BrancheNameEN}} Branch 
</div>
  
<div class="row p-2">
<div class="col-md-12">
 <b-form-checkbox  v-for="f in camp.faculties" :key="f.BranchId"  :value="f.FacultyBranchID" class="col-12" @change="FacultiesInsert(f.FacultyBranchID)"> {{f.FacultyNameEN}}</b-form-checkbox> 

   </div>
   
</div>

</div>
</div>


</div>


</b-form-checkbox-group>
      </b-form-group>

<div class="">

<b-form-group id="input-group-12" v-slot="{ ariaDescribedby }">
    <b-form-checkbox-group v-model="form.checkedDiscount" id="checkboxes-12" :aria-describedby="ariaDescribedby">
      <div class="row mb-3">
      <div class="col-md-4"></div>

        <div class="col-md-4">
          <div class="border">
              <div class="title"> Discounts  
          </div>
            
            <div class="row p-2">
              <div class="col-md-12">
                <b-form-checkbox  v-model="form.Discounts" name="Discounts" 
                      v-for="dis in Discounts" :key="dis.Serial"  :value="dis.DiscountID" @change="AddDiscountToInquiry(dis.DiscountID)" class="col-12">
                      {{dis.NameEN}} 
                </b-form-checkbox> 

              </div>
              
            </div>

          </div>
      </div>

    </div>

     <div class="mt-5 text-right float-right w-100"> 
     <button class="nav-link btn btn-primary text-right float-right" type="submit" @click="onSubmit">Done</button> 
<a class="nav-link btn btn-success text-right float-right" id="v-pills-Current-tab" data-toggle="pill" href="#v-pills-Current" role="tab" aria-controls="v-pills-Current ">Back</a>

</div>

    </b-form-checkbox-group>
</b-form-group>


<!--  -->
<!-- <div  class="col-12 col-md-6 mb-1">

  <b-form-group id="input-group-8" label="Employee impression:" label-for="input-8">
          <b-form-select id="input-8" v-model="form.impressions" name="impressions" required >
          
        <option v-for="imp in impressions" :key="imp.Serial" :value="imp.Serial">
            {{imp.ImpressionEN}}
        </option>

          </b-form-select>
  </b-form-group>
    
</div> -->

        <!-- <div  class="col-12 col-md-6 mb-1">
     <b-form-group id="input-group-9" label="Discount:" label-for="input-9">
        <b-form-select
          id="input-9"
          v-model="form.Discount"
          :options="DiscountL"
          required
           
        ></b-form-select>
      </b-form-group>
         

       
        
        </div> -->



</div>

 </b-form>



      </div>
    </div>
  </div>
</template>
<script>
import EventService from '../../services/Event/event.services'

export default {
  name: "Next",
  data() {
    return {

        Loading: true,
        empty: false,
       

        form: {
          impressions:[],
          Discount: null,
          checked: '', 
          checkedDiscount: [], 
          selectEvent: [],
          FacultiesInterestedINTwo:[],
          FacultiesInterestedINOne:[],
          Discounts: [],
        },  
            impressions: [],
            selectEvent: [],
            Discounts: [],
            checkedDiscount: [], 
            DiscountL: [{ text: 'Select One', value: null }, '10%', '20%', '30%', '40%'],
        show: true, 
    campusData : [] ,
campFac : [],
FacInsert: [],
DiscountToInquiry:[],
fac : false

    };
  },
  // computed:{
  //   checkedFaculty(){
  //     this.form.checked.filter((item , index)=>{

  //     })
  //   }

  // },
    computed: {

    currentUser(){
      return this.$store.state.auth.user.LoginInfo[0].UserID;
    },
    
  },
   mounted(){
     
      EventService.SelectMarketingEvent(this.$route.params.Serial).then(Response =>{
              
               this.selectEvent = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
               console.log('Desciption Event => ',this.selectEvent)
           }, error => {
              this.empty = true;
              this.Loading = false ;
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

            EventService.SelectAllCampus().then(Response =>{
              this.campusData = Response.data;
                 this.campusData.forEach((campus,index)=> {
                 EventService.FacultyActiveByBranchAPI(campus.BranchSerial).then(result =>{
                   this.campusData[index].faculties = result.data
                   
                 })
                
            })

            }).finally(()=>{
             
             setTimeout(()=>{
           this.campFac =  this.campusData 
                  this.Loading = false ;
                  //  console.log("ca,p ",this.campFac)
             },2000)
            })


       EventService.GetAll_Impressions().then(Response =>{
               this.impressions = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
               //console.log('impression => ',this.impressions)
           }, error => {
              this.empty = true;
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

            EventService.IED_LookupDiscounts_SelectALL().then(Response =>{
               this.Discounts = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
               //console.log('impression => ',this.Discounts)
           }, error => {
              this.empty = true;
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

           

 
 },

    methods: {
    reloadPage() {
      window.location.reload();
    },
     onSubmit(event) {
        event.preventDefault()
        //alert(JSON.stringify(this.form)),
        window.location.reload();
      },

        FacultiesInsert(serial){

          EventService.BD_Faculties_Insert(this.$route.params.Serial,serial, this.currentUser).then(Response =>{
             
               this.FacInsert= Response.data
               this.empty =false
                // eslint-disable-next-line no-console
                 console.log('FacInsert => ', this.FacInsert)
           }, error => {
             this.empty = true;
            
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

      },

      AddDiscountToInquiry(DiscountID){

          EventService.AddDiscountToInquiry(DiscountID,this.$route.params.Serial, this.currentUser ).then(Response =>{
             
               this.DiscountToInquiry= Response.data
               this.empty =false
                 // eslint-disable-next-line no-console
                 console.log('DiscountToInquiry => ', this.DiscountToInquiry)
           }, error => {
             this.empty = true;
            
                 
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

      }
  },



};
</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}

.title{
    background: #285475;
    color:#fff;
    width: 200px;
    margin: 0 auto;
    font-size: 20px;
    text-align: center;
    padding: 10px 0px;
   border-radius: 0px 0px 15px 15px;

}
</style>